import classNames from 'classnames';
import { ReactComponent as IconDownload } from '../img/iconDownload2.svg';
import { FC } from 'react';
import styles from './TemplateLink.module.scss';
import { formatCustomDateContract } from 'utils/date';
import { useGetWorkersStoplistReportMutation } from 'redux/Api/employedsApi/employedsApi';

interface TemplateLinkProps {
  hasFile: boolean;
  dateUploadReestr?: string | null;
}

export const TemplateLink: FC<TemplateLinkProps> = ({ hasFile, dateUploadReestr }) => {
  const templateUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_WORKERS_STOPLIST_UPLOAD_TEMPLATE_PATH}`;

  const [getWorkersStoplistReport] = useGetWorkersStoplistReportMutation();

  const handleUploadFile = async () => {
    try {
      const result = await getWorkersStoplistReport();

      if ('data' in result && result.data) {
        const { blob } = result.data;
        const filename = 'workers-stoplist-report.xlsx';

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Ошибка получения шаблона');
      }
    } catch (error) {
      console.error('Ошибка скачивания шаблона:', error);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.BlockReestr}>
        <p>Новый реестр</p>
        <a className={classNames(styles.link, styles.template)} href={templateUrl}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            Скачать шаблон <IconDownload />
          </div>
        </a>
      </div>
      {dateUploadReestr && (
        <div className={styles.BlockReestr_uploaded}>
          <p>Загружен {formatCustomDateContract(dateUploadReestr)}</p>
          <button
            className={classNames(styles.link, styles.template)}
            style={!hasFile ? { marginBottom: '4px' } : {}}
            onClick={handleUploadFile}
            type='button'>
            Скачать реестр
            <IconDownload />
          </button>
        </div>
      )}
    </div>
  );
};
